// Korean translations
export const koreanTranslations = {
  header: {
    title: "파트너십 및 협력 페이지",
    subtitle: "신뢰할 수 있는. 혁신적인. 협력하는.",
    breadcrumb: {
      home: "홈",
      current: "파트너십 및 협력 페이지",
    },
  },
  introduction: {
    paragraph1:
      "1998년에 설립된 **비즈니스 오토메이션 리미티드(Business Automation Limited)**는 방글라데시 최초의 IT 기반 서비스(ITES) 제공업체 중 하나로서, “현지의 필요에 맞춘 세계적 수준의 디지털 솔루션을 통해 조직을 강화한다”는 대담한 비전을 가지고 출범했습니다. 27년이 넘는 세월 동안 우리는 방글라데시 및 그 밖의 지역에서 300개 이상의 공공 및 민간 부문 고객에게 서비스를 제공하며 전자정부(e-Government) 혁신의 신뢰받는 이름으로 성장해왔습니다.",
    paragraph2:
      "우리의 솔루션은 기업용 소프트웨어, 시민 서비스 포털, IoT 기반 시스템, 워크플로 자동화 등 다양한 형태로 제공되며, 서비스 품질 향상, 운영 효율성 증대, 그리고 포용적 디지털 성장 촉진에 기여하고 있습니다. 본사는 **방글라데시 다카(Dhaka)**에 위치하고 있으며, 사내 연구개발(R&D), 현대적인 UI/UX 실험실, 그리고 강력한 사후 지원 생태계를 통해 엔드투엔드(End-to-End) 플랫폼을 제공합니다. 또한, 여성 및 젊은 전문가들로 구성된 다학제적 팀은 스마트 키오스크, 고객 서비스 관리 도구, 그리고 수백만 명이 이용하는 국가 규모의 자동화 플랫폼 등 사회에 실질적인 영향을 미치는 다양한 시스템을 개발해왔습니다.",
    paragraph3:
      "ISO 9001, ISO 20000, 및 ISO 27000 인증을 받은 기관으로서, 우리는 지역 중소기업(SME) 프로젝트부터 국가적 디지털 전환 이니셔티브에 이르기까지 모든 사업에서 탁월한 품질과 전문성을 유지하고 있습니다. 또한, 우리의 포용적인 근무 환경은 멘토십 프로그램, 유연 근무제, 그리고 AI/RPA 교육을 통해 여성과 젊은 전문가들이 성장할 수 있도록 지원하며, 방글라데시의 다양하고 역동적인 인재상을 반영한 팀 문화를 조성하고 있습니다.",
    paragraph4:
      "정부 기관의 역량 강화를 지원하든, 글로벌 기관과의 협력을 추진하든, **비즈니스 오토메이션(Business Automation)**은 적합한 인재, 도구, 그리고 비전을 바탕으로 도전을 기회로 바꾸는 힘을 제공합니다.",
  },
  howWeCanHelp: {
    title: "우리가 도와드릴 수 있는 방법",
    subtitle:
      "방글라데시에서 저희를 현지 파트너로 선택하시면, 다음과 같은 혜택을 기대하실 수 있습니다",
    services: [
      {
        title: "현지 지원(On-The-Ground Support)",
        description:
          "시간대, 문화적 차이, 언어 장벽 등으로 인해 국제 비즈니스가 어려울 수 있습니다. 저희는 방글라데시에서 귀하의 프로젝트를 지원함으로써 이러한 문제를 해결해 드립니다.",
      },
      {
        title:
          "방글라데시 법규 및 거버넌스 준수 역량(Capacity and Capability to Work within Laws and Governance of Bangladesh)",
        description:
          "국제 비즈니스에서는 법률과 규정을 준수하는 것이 매우 중요하며, 저희의 관련 전문 지식은 절차를 간소화하고 처리 시간을 단축하는 데 도움을 줍니다.",
      },
      {
        title:
          "데이터 입력, 매핑 및 확장 솔루션(Data Entry, Mapping & Scaling Solutions)",
        description:
          "저희는 정확한 데이터 입력, 처리, 지리 매핑, 구역 생성, 지도 플랫폼 통합 서비스를 제공하며, 비즈니스 성장을 위한 확장 가능한 IT 인프라도 함께 제공합니다.",
      },
      {
        title: "포용적 조직 문화(Inclusive Culture)",
        description:
          "저희 100명 이상의 팀은 25%가 여성 및 젊은 전문가로 구성되어 있으며, 다양성을 바탕으로 혁신을 이끌고 있습니다.",
      },
      {
        title: "전국적 네트워크(Nationwide Reach)",
        description:
          "저희는 수도뿐만 아니라 도시와 농촌 지역을 포함한 방글라데시 전역에서 프로젝트를 실행할 수 있는 역량을 갖추고 있습니다.",
      },
      {
        title: "입증된 전문성(Proven Expertise)",
        description:
          "저희는 글로벌 솔루션을 현지 기술, 사용자 인터페이스, 인프라와 원활하게 통합하여, 글로벌 시스템과 현지 시스템 간의 무결점 연결과 통합을 보장합니다.",
      },
      {
        title: "유지보수 및 운영 지원(Maintenance & Operational Support)",
        description:
          "저희는 **사전 모니터링, 신속한 문제 해결, 포괄적인 연간 유지보수 계약(AMC)**과 함께 다국어 지원이 가능한 전담 24/7 기술 헬프데스크를 제공하여 시스템 다운타임을 최소화합니다. 예를 들어, 저희는 BCIC, BIDA, A2i, RAJUK, JICA 등에도 지속적인 기술 지원을 제공하고 있습니다.",
      },
      {
        title: "교육 및 역량 강화(Training & Capacity Building)",
        description:
          " 저희는 대면 및 온라인 형식의 체계적인 교육 프로그램을 진행하여 제품 도입을 촉진하고, 현지 팀과 유통 파트너가 성공할 수 있는 지식과 역량을 갖출 수 있도록 지원합니다. 예를 들어, 저희는 JICA, RAJUK, A2i, BIDA, UNDP, World Bank, BEPRC, BTRC, BHTPA, BCSIR, BASIS 등 다양한 프로젝트에서 워크숍을 진행한 바 있습니다.",
      },
    ],
  },
  //   trustedPartner: {
  //     title: "우리가 신뢰할 수 있는 파트너인 이유",
  //     subtitle: "간단히 말해서, 귀하의 요구사항이 우리의 우선순위이며 기본적인 일률적 솔루션을 넘어섭니다. 우리와 함께하면 귀하에게 특별히 맞는 기술 솔루션을 받게 됩니다. 또한 우리는 다음을 보유하고 있습니다:",
  //     trackRecordTitle: "우리의 실적이 모든 것을 말해줍니다:",
  //     stats: [
  //       {
  //         number: "27년 이상",
  //         title: "거의 30년의 유산을 가진 방글라데시의 선도적인 ITES 회사."
  //       },
  //       {
  //         number: "300+",
  //         title: "30개 이상의 부처를 포함하여 300개 이상의 공공 부문 기관의 신뢰를 받고 있습니다"
  //       },
  //       {
  //         number: "10+",
  //         title: "10개 이상의 국가/지방 전자정부 플랫폼에 참여"
  //       }
  //     ],
  //     trackRecord: [
  //       {
  //         text: "서비스 및 프로세스 단순화를 위한 고객과의 참여."
  //       },
  //       {
  //         text: "방글라데시에서 가장 큰 제3자 통합 중 하나의 경험",
  //         linkText: "(더 알아보기)"
  //       },
  //       {
  //         text: "다양한 정부 기관에서 공공 데이터 분석의 성공적인 구현 기록. (SDG 추적, A2i 대시보드, 에너지 관리, 공공 서비스 관리 등)"
  //       },
  //       {
  //         text: "국가 데이터센터와 4급 데이터센터를 포함한 다양한 데이터센터에서 호스팅되는 서버 관리 및 devOps 서비스 제공.",
  //         linkText: "(더 알아보기)"
  //       },
  //       {
  //         text: "대규모 데이터 및 데이터 마이그레이션 관리 경험 (2100만 건 이상의 레코드, 데이터 크기 175TB 이상의 최대 경험)"
  //       },
  //       {
  //         text: "우리의 교육 플랫폼을 사용한 전국적인 교육 서비스 제공 경험."
  //       },
  //       {
  //         text: "성공적인 프로젝트 출시를 위한 기록 디지털화 (데이터 입력, 문서 및 지도 스캔 등) 경험.",
  //         linkText: "(더 알아보기)"
  //       },
  //       {
  //         text: "우리의 고객 서비스 플랫폼을 통해 프로젝트에서 요구하는 기술 지원 서비스 제공 경험",
  //         linkText: "(더 알아보기)"
  //       }
  //     ]
  //   },
  //   trackRecord: {
  //     title: "우리의 실적",
  //     subtitle: "디지털 솔루션 제공에서 입증된 우수성",
  //     items: [
  //       {
  //         icon: "/png/pc_1.png",
  //         alt: "참여",
  //         text: "서비스 및 프로세스 간소화를 위한 고객과의 참여.",
  //         hasLink: false,
  //       },
  //       {
  //         icon: "/png/pc_2.png",
  //         alt: "API 통합",
  //         text: "방글라데시에서 가장 큰 3rd party 통합 경험 중 하나",
  //         hasLink: true,
  //         linkText: "(더 알아보기)",
  //         linkUrl: "/services/api-integration",
  //       },
  //       {
  //         icon: "/png/pc_3.png",
  //         alt: "분석",
  //         text: "다양한 정부 기관에서 공공 데이터 분석의 성공적인 구현 기록 (SDG 추적, A2i 대시보드, 에너지 관리, 공공 서비스 관리 등)",
  //         hasLink: false,
  //       },
  //       {
  //         icon: "/png/pc_4.png",
  //         alt: "서버 관리",
  //         text: "국가 데이터 센터 및 4계층 데이터 센터를 포함한 다양한 데이터 센터에서 호스팅되는 서버 관리 및 DevOps 서비스 제공.",
  //         hasLink: true,
  //         linkText: "(더 알아보기)",
  //         linkUrl: "/services/devops-services",
  //       },
  //       {
  //         icon: "/png/pc_5.png",
  //         alt: "데이터 관리",
  //         text: "대규모 데이터 및 데이터 마이그레이션 관리 경험 (2100만+ 레코드, 데이터 크기 175+ TB의 최대 경험)",
  //         hasLink: false,
  //       },
  //       {
  //         icon: "/png/pc_6.png",
  //         alt: "교육",
  //         text: "우리의 교육 플랫폼을 사용한 전국적인 교육 서비스 제공 경험.",
  //         hasLink: false,
  //       },
  //       {
  //         icon: "/png/pc_7.png",
  //         alt: "디지털화",
  //         text: "성공적인 프로젝트 출시를 위한 기록 디지털화 (데이터 입력, 문서 및 지도 스캔 등) 경험.",
  //         hasLink: true,
  //         linkText: "(더 알아보기)",
  //         linkUrl: "/services/record-digitization-services",
  //       },
  //       {
  //         icon: "/png/pc_8.png",
  //         alt: "지원",
  //         text: "우리의 고객 서비스 플랫폼을 통해 프로젝트에서 요구하는 기술 지원 서비스 제공 경험",
  //         hasLink: true,
  //         linkText: "(더 알아보기)",
  //         linkUrl: "/services/tech-support-services",
  //       },
  //     ],
  //   },
  //   collaboration: {
  //     title: "우리가 귀하와 협력할 수 있는 방법",
  //     subtitle: "역동적이고 다양한 비즈니스 환경에서는 당면한 프로젝트의 요구사항에 따라 다양한 형태의 파트너십이 필요합니다. 우리는 다음과 같은 잠재적인 협력 모드 옵션을 제공하여 이에 적응합니다:",
  //     modes: [
  //       {
  //         title: "기술 전달 파트너",
  //         description: "컨설턴트나 프로젝트를 위한 완전한 전문성과 원활한 통합을 제공합니다."
  //       },
  //       {
  //         title: "공동 제안",
  //         description: "G2P에서 건강 및 교육 플랫폼까지 정부 RFP를 위한 승리 입찰을 공동 생성합니다."
  //       },
  //       {
  //         title: "기술 라이선싱",
  //         description: "귀하의 이니셔티브를 위해 우리의 플랫폼을 라이선스하고 확장합니다."
  //       },
  //       {
  //         title: "아웃소싱 팀",
  //         description: "시간 제한이 있는 임무를 위한 전용 개발 또는 지원을 제공합니다."
  //       },
  //       {
  //         title: "프레임워크 협정",
  //         description: "장기 국가 출시 또는 몇 년 후 L&T와의 기술 이전 과제를 지원합니다."
  //       }
  //     ],
  //     conclusion: "우리는 방글라데시라는 우리의 본거지든 글로벌 환경이든 다양한 분야의 잠재적 고객과의 파트너십을 항상 장려해 왔습니다. 따라서 새로운 시대로 나아가면서, 우리는 신뢰할 수 있는 전문가 팀을 통해 전 세계적으로 더 높은 품질의 맞춤형 기술 솔루션을 제공하기를 기대합니다."
  //   }
  contact: {
    inquiryText: "자세한 내용은 아래 링크를 통해 문의해 주시기 바랍니다.",
    buttonText: "문의하기",
    hashtags: "#비즈니스오토메이션 #방글라데시IT기업 #디지털트랜스포메이션 #글로벌파트너십 #전자정부 #IoT솔루션 #워크플로자동화 #국제비즈니스지원 #여성임파워먼트 #ISO인증기업"
  },
  feedback: {
    question: "이 정보가 도움이 되었나요？",
    yes: "예",
    no: "아니요",
    thankYou: "피드백을 주셔서 감사합니다！",
    modalTitle: "죄송합니다. 개선 방법을 알려주십시오.",
    placeholder: "텍스트 박스 - 최대 250자",
    submit: "제출"
  }
};
